import React, { useEffect, useState,useRef } from 'react';
import Header from '../components/header';
import AppBalanceBar from '../components/AppBalanceBar';
import Footer from '../components/footer';
import download from '../assets/images/download.png';
import cricket from '../assets/images/cricket.png';
import { FaWhatsapp } from 'react-icons/fa';
import Nav from '../components/Navigation';
import Bottomtab from '../components/BottomTab'
import { useNavigate } from "react-router-dom";
import MainSection from "../components/MainSection";
import axios from 'axios';
import { Icons } from '../content/Icons';
import { GrCopy } from "react-icons/gr";
import Modal from 'react-bootstrap/Modal';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Helmet } from "react-helmet";
import HomeSEO from "../components/seo-components/HomeSEO"

const Homepage = () => {
  const navigate = useNavigate();

  const user = localStorage.getItem('user');
  const parsedUser = JSON.parse(user);

  const [whatsappNumber, setWhatsappNumber] = useState('');
  


  const [videoLink, setvideoLink] = useState("");
  const videoRef = useRef(null);

  const fetchwhatsappnum = async () => {
    const params = new URLSearchParams();
    params.append('table_name', 'status');

    try {
      const source = axios.CancelToken.source();
      const timeout = setTimeout(() => {
        source.cancel();
      }, 20000); // 20 seconds timeout

      const response = await axios.post('https://api.betprowallet.pk/ft_status.php', params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        cancelToken: source.token,
      });

      clearTimeout(timeout);

      // Check if response starts with "0 results"
      if (response.data && typeof response.data === 'string' && response.data.startsWith('0 results')) {
        // Handle user not found scenario

        return null; // or handle it as needed
      }

      // Proceed if user data is available
      if (response.data.length > 0) {


        if (response.data[0].status_on === "1") {

          setWhatsappNumber(response.data[0].status_msg);
          setvideoLink(response.data[0].youtube_link);


        } else {
          setWhatsappNumber('');
        }

      }

    } catch (error) {
      if (axios.isCancel(error)) {
        // console.log('Request canceled', error.message);
      } else {
        // console.error('Error fetching user data', error);
      }
    }
  };


   useEffect(() => {
    if (videoLink && videoRef.current) {
      videoRef.current.load(); // reload video when link updates
    }
  }, [videoLink]);


  fetchwhatsappnum();

  const fetchUserData = async () => {
    const params = new URLSearchParams();
    params.append('username', parsedUser.email);
    params.append('fieldName', 'user_email');
    params.append('table_name', 'users');

    try {
      const source = axios.CancelToken.source();
      const timeout = setTimeout(() => {
        source.cancel();
      }, 20000); // 20 seconds timeout

      const response = await axios.post('https://api.betprowallet.pk/loginUserApi_ft.php', params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        cancelToken: source.token,
      });

      clearTimeout(timeout);

      // Check if response starts with "0 results"
      if (response.data && typeof response.data === 'string' && response.data.startsWith('0 results')) {
        // Handle user not found scenario

        return null; // or handle it as needed
      }

      // Proceed if user data is available
      if (response.data.length > 0) {

         if(response.data[0].user_blocked === '0'){

        const newUser = {
          name: response.data[0]?.user_fullname || 'User',
          bp_username: response.data[0]?.user_betpro_username || '',
          bp_pass: response.data[0]?.user_betpro_password || '',
          email: response.data[0]?.user_email || '',
          password: '',
          number: response.data[0]?.user_whatsapp || 'N/A',
          userID: response.data[0]?.user_id || 'N/A',
          userActive: response.data[0]?.user_active || 0,
          withdrawAmount:response.data[0]?.withdraw_amount || 25000,
        };

        const existingUser = JSON.parse(localStorage.getItem('user'));


        
       


        // Compare new user data with existing user data
        if (localStorage.getItem('user') && JSON.stringify(existingUser) !== JSON.stringify(newUser)) {

          // Update local storage
          localStorage.setItem('user', JSON.stringify(newUser));
          // Refresh the page
          window.location.reload();
        }else if (!(localStorage.getItem('user'))){
         
        
         
        }

       

      } else {
        localStorage.removeItem('user');
        navigate('/');
      }
    }

    } catch (error) {
      if (axios.isCancel(error)) {
        // console.log('Request canceled', error.message);
      } else {
        // console.error('Error fetching user data', error);
      }
    }
  };

  // Call fetchUserData periodically
  const startUserListener = () => {



    checkUser(); // Initial fetch
    const intervalId = setInterval(checkUser, 5000); // Check every 30 seconds

    // Cleanup on component unmount or when you no longer need the listener

    return () => clearInterval(intervalId);

  

  };


 const checkUser = ()=> {

  if(user){

   
    fetchUserData();

  }


 }

 




  useEffect(() => {

    if (!user) {
      navigate('/');
    } else {

      startUserListener();

       // Use this function to start the listener when needed (e.g., on component mount)
 


    }
  }, [navigate]);

  const handleGoToWebsite = () => {
    // console.log("handle Go To Bet Pro website Button");
  }

  const handledepositclick = () => {
    navigate('/deposit')
  }


  const handlewhatsappclick = () => {


    if (whatsappNumber.trim() !== '') {
      const formattedNumber = whatsappNumber.replace(/\D/g, ''); // Remove any non-numeric characters
      const whatsappLink = `https://wa.me/${formattedNumber}`; // Create the WhatsApp link

      // Redirect to the WhatsApp link
      window.open(whatsappLink, '_blank');
    } else {
      // console.log('WhatsApp number is empty');
      // Optionally, you can show an error message to the user here
    }

  }

  const handlewithdrawclick = () => {
    navigate('/withdraw')
  }


  const handleCopyClick = (copyTxt) => {

    setMsg(copyTxt + ' copied successfully');
    handleShow();
  };


  const [show, setShow] = useState(false);
  const [Msg, setMsg] = useState('');

  const handleShow = () => setShow(true);

  const handleClose = function () {
    setShow(false);


  };


  return (
    <div>

       <HomeSEO />
      <AppBalanceBar/>

      <Header />
      <div className="login-wrapper2">
        <div className="main-login">
          <div className="container" style={{ padding: "0 1rem", maxWidth: "28rem" }}>


            <div className="row align-items-top">
              <div className="col-md-12">
                <div className="left-login-box1">
                  <div className="fieldset">
                    <div className="title mt-2">





                      {parsedUser.userActive == 1 ? (
                        <>
                          <h2 className="">My Betpro ID</h2>
                        </>
                      ) : (
                        <>
                          <h2 className="">Active Betpro ID</h2>
                        </>
                      )}



                      {parsedUser.userActive == 1 && (
                        <>
                          <div className="account3 mt-2">
                            <div className="whatappp  ">
                              <div className="btn-active-account2">
                                <CopyToClipboard text={parsedUser.bp_username}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h5 style={{ margin: 0 }}>
                                      Username: <span className="ic-copy" style={{ marginLeft: '4px' }}>{parsedUser.bp_username}</span>
                                    </h5>
                                    <GrCopy className="icon" onClick={() => handleCopyClick('Betpro username')} style={{ marginLeft: "10px" }} />
                                  </div>
                                </CopyToClipboard>
                              </div>




                            </div>
                            <div className="whatappp ">

                              <div className="btn-active-account2">
                                <CopyToClipboard text={parsedUser.bp_pass}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h5 style={{ margin: 0 }}>
                                      Password: <span className="ic-copy" style={{ marginLeft: '4px' }}>{parsedUser.bp_pass}</span>
                                    </h5>
                                    <GrCopy className="icon" onClick={() => handleCopyClick('Betpro password')} style={{ marginLeft: "10px" }} />
                                  </div>
                                </CopyToClipboard>
                              </div>

                            </div>
                          </div>

                        </>)}

                      {parsedUser.userActive == 0 && (
                        <>
                          {/* <div className="account mt-3">
                            <h3 className="text-center  mb-3"> ضروری ہدایات</h3>


                            <ul>
                              <li className="mb-3">  ڈپازٹ کرنے کے بعد آپ کا Betpro اکاؤنٹ ایکٹیو ہو جائے گا۔</li>
                              <li className="mb-3"> <>Betpro کا username اور password </>یہاں پر ظاہر ہوگا۔</li>
                              <li className="mb-3">ڈپازٹ کی گئی رقم آپ کی Betpro اکاؤنٹ میں شامل کی جائے گی۔ </li>
                            </ul>
                          </div> */}


                       <div className="user-instructions">
                        <h2 className='user-title pb-3'>New user instructions</h2>
                     
                        <div className="flex items-center pb-3">
                            <div className='pr-2'>
                                <img src={Icons.icon1} alt="infoIcon" className='instruction-icon' />
                            </div>
                            <div>
                                <p className='instruction-text' style={{ lineHeight: '12.1px' }}>1st deposit karne per apka Betpro account active hojae ga or ID & password uper show hojae ge.</p>
                            </div>
                        </div>
                        <div className="flex items-center pb-3">
                            <div className='pr-2'>
                                <img src={Icons.icon2} alt="infoIcon" className='instruction-icon' />
                            </div>
                            <div>
                                <p className='instruction-text' style={{ lineHeight: '12.1px' }}>Deposit ki gayi raqam apke Betpro account me add hojae gi.</p>
                            </div>
                        </div>

                        <div className="flex items-center pb-3">
                            <div className='pr-2'>
                                <img src={Icons.icon3} alt="infoIcon" className='instruction-icon' />
                            </div>
                            <div>
                                <p className='instruction-text' style={{ lineHeight: '12.1px' }}>Deposit karne ke 10 minutes baad apki id activate ho jaye gi.</p>
                            </div>
                        </div>
                    </div>


                        </>)}


                         {parsedUser.userActive == 1 ? (
                        <>

                      <div className="withdraw mb-3 mt-2">
                        <button className="col-6 cus-btn3 btn btn-default dep_btn" onClick={handledepositclick}>
                          <h5>
                            <span className=""></span>+ Deposit
                          </h5>
                        </button>
                        <button className="col-6 cus-btn3 btn btn-default with_btn" onClick={handlewithdrawclick}>
                          <h5>
                            <span className=""></span>Withdraw
                          </h5>
                        </button>
                      </div>
 </>
                      ) : (
<>

                        <div className="activate-btn mt-4 mb-3">
                       
                        <button className="col-12 cus-btn3 btn btn-default" onClick={handledepositclick}>
                          <h5>
                            <span className=""></span>Activate Betpro account
                          </h5>
                        </button>
                      </div>

                         


 </> )}

                      {/* <div className="whatappp  mb-3 text-center">
                        <button className="btn-whatappp" onClick={handlewhatsappclick}><h5><FaWhatsapp style={{ color: 'green', fontSize: '1.5em', marginRight: '3px' }} />Contact on Whatapp</h5></button>
                      </div> */}

                    </div>


                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>


      <MainSection />

        
      {/* <div className="container text-center" style={{ padding: "0 1rem", maxWidth: "28rem",marginBottom:"150px" }}>
  <h5>How to active Betpro 🆔</h5>
  <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%', backgroundColor: '#000' }}>
    <iframe
      title="Login Tutorial"
      src="https://www.youtube.com/embed/lnofPPlTSWY"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
    ></iframe>
  </div>
</div> */}

<div className="container text-center" style={{ padding: "0 1rem", maxWidth: "28rem", marginBottom: "150px" }}>
  <h5>How to active Betpro 🆔</h5>
  <div
    style={{
      position: "relative",
      paddingBottom: "56.25%",
      height: 0,
      overflow: "hidden",
      maxWidth: "100%",
      backgroundColor: "#000",
    }}
  >
     <video
          ref={videoRef}
          controls
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        >
       <source src={videoLink} type={"video/mp4"} />

       
   

      Your browser does not support the video tag.
    </video>
  </div>
</div>


      {/* <Nav /> */}

      <Bottomtab/>

      {/* Modal for messages */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header >
          <Modal.Title>Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{Msg}</p>
          <hr />
          <p onClick={handleClose} className="model-ok">Ok</p>
        </Modal.Body>

      </Modal>

    </div>
  )
}

export default Homepage;
